// Centralised UI feature flags.
//
// Each flag defaults to ON (current behaviour preserved). To hide a feature,
// set the matching REACT_APP_* env var to the exact string "false" in
// /app/frontend/.env, then restart the frontend.
//
// Added Jun 10 2026 for the SI Agentic board demo (Mon Jun 15 2026).
// We HIDE — never delete — public-beta marketing UI so it can be flipped
// back on for the public launch.

const off = (v) => String(v).toLowerCase() === 'false';

// Step 1 & Step 2 onboarding walkthrough on the login page, plus the
// "Replay walkthrough" link underneath the login form.
export const SHOW_WALKTHROUGH = !off(process.env.REACT_APP_SHOW_WALKTHROUGH);

// 3-query-limit QuotaDemoBox shown above and below the results thread,
// plus the "Demo viewed" callout it carries.
export const SHOW_DEMO_COUNTER = !off(process.env.REACT_APP_SHOW_DEMO_COUNTER);

// Control Centre / Accuracy Controls hover tags & inline "Heads up" callouts
// that nudge first-time users. Includes:
//  - Control Centre <br> hover label (top bar)
//  - inline-cc-callout under the top icon row
//  - FloatingTopIcons "Heads up" callout
//  - QuotaDemoBox CC hint
export const SHOW_CC_HINTS = !off(process.env.REACT_APP_SHOW_CC_HINTS);

// Public-Beta investor-campaign UI: the SessionExitBanner with "invest with us"
// copy + the signup-page "Create your Beta account" affordances. Hidden for
// enterprise / board-demo posture; live for public beta.
export const SHOW_BETA_BANNERS = !off(process.env.REACT_APP_SHOW_BETA_BANNERS);

// SPD v5.72 (2026-02-11) — Nuclear-execution gate for Beta.
// The Nuclear intro + confirm screens remain fully visible so testers can
// exercise the flow, but the FINAL red "Confirm: Go Nuclear!" button is
// disabled to prevent accidental account destruction during Beta. Flip
// REACT_APP_NUCLEAR_ENABLED=true in the deployed .env for GA.
// Defaults to DISABLED (safe-by-default for Beta).
export const NUCLEAR_ENABLED = String(process.env.REACT_APP_NUCLEAR_ENABLED).toLowerCase() === 'true';
